import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./DeliveryVehicleBank.css";

function DeliveryVehicleBank() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({

        vehicleType: "",

        vehicleNumber: "",

        accountHolder: "",

        bankName: "",

        accountNumber: "",

        confirmAccountNumber: "",

        ifsc: "",

        upiId: ""

    });

    const [documents, setDocuments] = useState({

        aadhaarFront: null,

        aadhaarBack: null,

        drivingLicenseFront: null,

        drivingLicenseBack: null,

        rcBook: null,

        insurance: null

    });

    // ==========================
    // Handle Inputs
    // ==========================

    const handleChange = (e) => {

        const {

            name,

            value

        } = e.target;

        setFormData((prev) => ({

            ...prev,

            [name]: value

        }));

    };

    // ==========================
    // Handle File Upload
    // ==========================

    const handleFile = (e) => {

        const {

            name,

            files

        } = e.target;

        setDocuments((prev) => ({

            ...prev,

            [name]: files[0]

        }));

    };
        // ==========================
    // Submit Application
    // ==========================

    const handleSubmit = async (e) => {

    e.preventDefault();

    try {

        if (
            formData.accountNumber !==
            formData.confirmAccountNumber
        ) {

            alert("Account numbers do not match.");

            return;

        }

        setLoading(true);

        // ==========================
        // Vehicle Details
        // ==========================

        await API.patch(

            "/delivery/vehicle",

            {

                vehicleType: formData.vehicleType,

                vehicleNumber: formData.vehicleNumber

            }

        );

        // ==========================
        // Documents Upload
        // ==========================

        const documentData = new FormData();

        if (documents.aadhaarFront) {

            documentData.append(
                "aadhaarFront",
                documents.aadhaarFront
            );

        }

        if (documents.aadhaarBack) {

            documentData.append(
                "aadhaarBack",
                documents.aadhaarBack
            );

        }

        if (documents.drivingLicenseFront) {

            documentData.append(
                "drivingLicenseFront",
                documents.drivingLicenseFront
            );

        }

        if (documents.drivingLicenseBack) {

            documentData.append(
                "drivingLicenseBack",
                documents.drivingLicenseBack
            );

        }

        if (documents.rcBook) {

            documentData.append(
                "rcBook",
                documents.rcBook
            );

        }

        if (documents.insurance) {

            documentData.append(
                "insurance",
                documents.insurance
            );

        }

       await API.patch(
    "/delivery/documents"
);

        // ==========================
        // Bank
        // ==========================

        await API.patch(

            "/delivery/bank",

            {

                accountHolder:
                    formData.accountHolder,

                bankName:
                    formData.bankName,

                accountNumber:
                    formData.accountNumber,

                ifsc:
                    formData.ifsc,

                upiId:
                    formData.upiId

            }

        );

        // ==========================
        // Submit Application
        // ==========================

        await API.post(

            "/delivery/application/submit"

        );

        alert(

            "Application Submitted Successfully."

        );

        navigate(

            "/delivery/application-submitted"

        );

    }

    catch (error) {

        console.log(error);

        alert(

            error.response?.data?.message ||

            "Something went wrong."

        );

    }

    finally {

        setLoading(false);

    }

};

    return (

        <div className="delivery-verification-page">

            <div className="delivery-verification-card">

                <div className="delivery-logo">

                    🚚

                </div>

                <h1>

                    HomeFoods

                </h1>

                <h2>

                    Vehicle, Documents & Bank

                </h2>

                <p>

                    Complete your verification details.

                </p>

                <form

                    onSubmit={handleSubmit}

                    className="delivery-form"

                >

                    {/* ==========================
                        Vehicle
                    ========================== */}

                    <div className="section-title">

                        🚗 Vehicle Details

                    </div>
                                        <div className="vehicle-types">

                        {

                            [

                                "Bike",

                                "Scooter",

                                "Cycle",

                                "Auto",

                                "Car",

                                "Tata Ace",

                                "Tata Sumo"

                            ].map((type) => (

                                <label
                                    key={type}
                                    className="vehicle-option"
                                >

                                    <input

                                        type="radio"

                                        name="vehicleType"

                                        value={type}

                                        checked={
                                            formData.vehicleType === type
                                        }

                                        onChange={handleChange}

                                    />

                                    {type}

                                </label>

                            ))

                        }

                    </div>

                    <div className="form-group">

                        <label>

                            Vehicle Number

                        </label>

                        <input

                            type="text"

                            name="vehicleNumber"

                            placeholder="KA01AB1234"

                            value={formData.vehicleNumber}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    {/* ==========================
                        Documents
                    ========================== */}

                    <div className="section-title">

                        📄 Documents

                    </div>

                    <div className="upload-grid">

                        <div className="upload-card">

                            <label>

                                Aadhaar Front

                            </label>

                            <input

                                type="file"

                                name="aadhaarFront"

                                accept="image/*"

                                onChange={handleFile}

                            />

                        </div>

                        <div className="upload-card">

                            <label>

                                Aadhaar Back

                            </label>

                            <input

                                type="file"

                                name="aadhaarBack"

                                accept="image/*"

                                onChange={handleFile}

                            />

                        </div>

                        <div className="upload-card">

                            <label>

                                Driving License Front

                            </label>

                            <input

                                type="file"

                                name="drivingLicenseFront"

                                accept="image/*"

                                onChange={handleFile}

                            />

                        </div>

                        <div className="upload-card">

                            <label>

                                Driving License Back

                            </label>

                            <input

                                type="file"

                                name="drivingLicenseBack"

                                accept="image/*"

                                onChange={handleFile}

                            />

                        </div>

                        <div className="upload-card">

                            <label>

                                RC Book (Optional)

                            </label>

                            <input

                                type="file"

                                name="rcBook"

                                accept="image/*"

                                onChange={handleFile}

                            />

                        </div>

                        <div className="upload-card">

                            <label>

                                Insurance (Optional)

                            </label>

                            <input

                                type="file"

                                name="insurance"

                                accept="image/*"

                                onChange={handleFile}

                            />

                        </div>

                    </div>

                    {/* ==========================
                        Bank Details
                    ========================== */}

                    <div className="section-title">

                        🏦 Bank Details

                    </div>

                    <div className="form-group">

                        <label>

                            Account Holder Name

                        </label>

                        <input

                            type="text"

                            name="accountHolder"

                            placeholder="Enter Account Holder Name"

                            value={formData.accountHolder}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    <div className="form-group">

                        <label>

                            Bank Name

                        </label>

                        <input

                            type="text"

                            name="bankName"

                            placeholder="Enter Bank Name"

                            value={formData.bankName}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    <div className="form-group">

                        <label>

                            Account Number

                        </label>

                        <input

                            type="text"

                            name="accountNumber"

                            placeholder="Enter Account Number"

                            value={formData.accountNumber}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    <div className="form-group">

                        <label>

                            Confirm Account Number

                        </label>

                        <input

                            type="text"

                            name="confirmAccountNumber"

                            placeholder="Confirm Account Number"

                            value={formData.confirmAccountNumber}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    <div className="form-group">

                        <label>

                            IFSC Code

                        </label>

                        <input

                            type="text"

                            name="ifsc"

                            placeholder="SBIN0001234"

                            value={formData.ifsc}

                            onChange={handleChange}

                            required

                        />

                    </div>

                    <div className="form-group">

                        <label>

                            UPI ID (Optional)

                        </label>

                        <input

                            type="text"

                            name="upiId"

                            placeholder="example@upi"

                            value={formData.upiId}

                            onChange={handleChange}

                        />

                    </div>

                    <div className="agreement-box">

                        <input

                            type="checkbox"

                            required

                        />

                        <span>

                            I certify that all the information
                            provided is true and correct.

                        </span>

                    </div>

                    <button

                        type="submit"

                        className="delivery-submit-btn"

                        disabled={loading}

                    >

                        {

                            loading

                                ?

                                "Submitting..."

                                :

                                "Submit Application"

                        }

                    </button>

                </form>

            </div>

        </div>

    );

}

export default DeliveryVehicleBank;